/**
 * @file High.jsx
 * @exports High
 */
import React from 'react'
const green = '#23ce6b'
const defaultColor = green

const High = ({ style }) => (
  <svg
    id='high-icon'
    preserveAspectRatio='xMidYMid meet'
    style={style}
    viewBox='0 0 18 18'
  >
    <title>high</title>
    <path
      fill={defaultColor}
      d='M 9,1 13,5 h -3 v 12 H 8 v -12 H 5 Z'
    />
  </svg>
)

export default High
